import { LOCALE_ID, Provider } from '@angular/core';

import { LocalizationService } from '@app/shared/services/localization.service';

export class LocaleId extends String {
  constructor(private localeService: LocalizationService) {
    super();
  }

  public toString(): string {
    return this.localeService.locale();
  }

  public valueOf(): string {
    return this.toString();
  }
}

export const LocaleProvider: Provider = {
  provide: LOCALE_ID,
  useClass: LocaleId,
  deps: [LocalizationService],
};
